import axios from 'axios'
import md5 from 'md5'
import Cookie from 'js-cookie'
import {
	Base64
} from 'js-base64'
import CryptoJS from 'crypto-js'

//线下
// export const baseUrl = 'http://localhost:8131/' //'http://192.168.2.219:8131/'  // http://api.wb365.net:8081/
// export const baseUrl =  'http://192.168.2.234:8131/'  // http://api.wb365.net:8081/
// export const baseUrl = 'https://wb365.eisong.cc:8081/'
export const baseUrl = 'https://wb365.net:8081/'
// 附件 
export const aliUrl = 'https://wb2024.oss-cn-beijing.aliyuncs.com/'

let appId = '8131'
let appKey = '806e21a9dd9d3ae2781879bb78d3a9b8'
/**
 * 通用HTTP请求方法
 * 上传附件时使用此方法获取上传地址，isreturn必须为true
 * METHOD包含GET、POST
 */
export const httpRequest = (params, method = 'GET', isreturn) => {
	let paramsTrim = {}
	let timestamp = Math.round(new Date().getTime() / 1000)
	let paramSort = Object.keys(params).sort()
	let signStr = appId + appKey + timestamp
	let sp = ''
	let postUrl = baseUrl + '?action=' + params.action + '&app_id=' + appId + '&timestamp=' + timestamp
	let postParams = {}

	for (let i = 0; i < paramSort.length; i++) {
		if (params[paramSort[i]] != undefined) {
			signStr += sp + paramSort[i] + '=' + params[paramSort[i]]
			sp = '&'
			paramsTrim[paramSort[i]] = params[paramSort[i]]
		}
	}

	paramsTrim.app_id = appId
	paramsTrim.timestamp = timestamp
	paramsTrim.sign = md5(signStr).toUpperCase()
	postUrl += '&sign=' + paramsTrim.sign
	if (isreturn) {
		let returnStr = baseUrl + '?'
		let sp = ''
		for (let key in paramsTrim) {
			returnStr += sp + key + '=' + paramsTrim[key]
			sp = '&'
		}
		return returnStr
	}

	// 登录参数
	let admin = getCookie('admin')
	let headers = {}
	if (admin['aid']) {
		headers['aid'] = admin.aid
	}

	if (method == "GET") {
		return new Promise((resolve, reject) => {
			axios.get(baseUrl, {
				params: paramsTrim,
				headers: headers
			}).then((response) => {
				resolve(response.data)
			}).catch((error) => {
				resolve({
					error: true,
					msg: error
				})
			})
		})
	} else {
		// 去除放入地址栏中的参数
		delete paramsTrim.action
		delete paramsTrim.app_id
		delete paramsTrim.timestamp
		delete paramsTrim.sign
		return new Promise((resolve, reject) => {
			axios.post(postUrl, paramsTrim, {
					headers: headers
				})
				.then(response => {
					resolve(response.data);
				})
				.catch((error) => {
					resolve({
						error: true,
						msg: error
					})
				})
		})
	}
}

// 获取COOKIE
export const getCookie = (type) => {
	let cookiestr = Cookie.get(type)
	return cookiestr ? JSON.parse(Base64.decode(cookiestr)) : {}
}

// 身份证验证
export const isCardNo = (num) => {
	if (num.length != 18) {
		return false
	}
	let re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
	var arrSplit = num.match(re);

	//检查生日日期是否正确
	var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
	var bCorrectDay;
	bCorrectDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[
			3])) &&
		(dtmBirth.getDate() == Number(arrSplit[4]));
	if (!bCorrectDay) {
		return false;
	} else {
		//检验18位身份证的校验码是否正确。
		//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
		var valnum;
		var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
		var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
		var nTemp = 0
		for (let i = 0; i < 17; i++) {
			nTemp += num.substr(i, 1) * arrInt[i];
		}
		valnum = arrCh[nTemp % 11];
		if (valnum != num.substr(17, 1)) {
			return false;
		}
	}
	return true;
}
//企业信用代码校验
export const validateUnifiedSocialCreditCode = code =>{
	
	  if (!code || code.length !== 18) return false;
	  
	  const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
	  if (!reg.test(code)) return false;
	  
	  const weights = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
	  const chars = '0123456789ABCDEFGHJKLMNPQRTUWXY';
	  let sum = 0;
	  
	  for (let i = 0; i < 17; i++) {
	    const c = code.charAt(i);
	    const pos = chars.indexOf(c);
	    sum += pos * weights[i];
	  }
	  
	  const checkCode = 31 - (sum % 31);
	  const lastChar = code.charAt(17);
	  const lastPos = chars.indexOf(lastChar);
	  
	  return (checkCode === lastPos) || (checkCode === 31 && lastPos === 0);
	
}

// 强密码验证
export const passwordCheck = value => {
	var arr = [],
		array = [1, 2, 3, 4, 5]
	if (value.length < 6) {
		//最初级别
		return 0
	}
	if (/\d/.test(value)) {
		//如果用户输入的密码 包含了数字
		arr.push(1)
	}
	if (/[a-z]/.test(value)) {
		//如果用户输入的密码 包含了小写的a到z
		arr.push(2)
	}
	if (/[A-Z]/.test(value)) {
		//如果用户输入的密码 包含了大写的A到Z
		arr.push(3)
	}
	if (/\W/.test(value)) {
		//如果是非数字 字母 下划线
		arr.push(4)
	}
	for (var i = 0; i < array.length; i++) {
		if (arr.indexOf(array[i]) == -1) {
			return array[i]
		}
	}
}

/**
 * 生成条型码或二维码码值
 * @param {Object} type 1设备2地点
 * @param {Object} id 唯一ID
 */
export const getBarCode = (type, id) => {
	// 干扰码
	var disturb = id % 10
	// 四位前面补零
	const idString = ('00000000' + (id * disturb).toString()).slice(-8)

	return (type === 1 ? 'SD' : 'SP') + disturb.toString() + idString + md5(idString).toUpperCase().substr(
		disturb, 6)
}
// 判断是否为手机号
export const phoneCheck = (phone) => {
	var re = new RegExp('(^[1][3,4,5,6,7,8,9][0-9]{9}$)')
	return re.test(phone)
}

// 判断是否为邮箱
export const emailCheck = (string) => {
	var re = new RegExp(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/)
	return re.test(string)
}

// 加密字符串
export const aesEncrypt = codeString => {
	var key = CryptoJS.enc.Utf8.parse(appKey)
	var srcs = CryptoJS.enc.Utf8.parse(codeString)
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		iv: CryptoJS.enc.Utf8.parse('87abe96b2dba9799'),
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.ZeroPadding,
	})

	return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}


